import { FC, useEffect, useState } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { deleteExperience, getActiveExperiences, getDurations } from '../../../services/teamExperienceService';
import { ExperienceSummary } from '../../teamExperiences/models/ExperienceSummaryModel';
import { formatDateShortIntl2 } from '../../../helpers/FormatDate';
import { GenericModel } from '../../teamExperiences/models/GenericModel';
import Pagination from '../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { showErrorAlert } from '../../../helpers/alert';
import { EXPERIENCE_STATUS } from '../../teamExperiences/models/ExperienceStatus';
import { useConfirmAction } from '../../../hooks/utils/useConfirmAction';
import { defaultProfileImage, defaultVerticalImage } from '../../../utils/constants';
import { handleImageErrorGray } from '../../../utils/UtilsFiles';
import { formatDurationLabel, formatUsdAmount, pickDurationName } from '../../../utils/dateValidations';
import { DeclineReasonsModal } from './DeclineReasonsModal';

interface PropsSectionDraft {
}

const SectionDraft: FC<PropsSectionDraft> = ({ }) => {
    const [durations, setDurations] = useState<GenericModel>([]);
    const [paginationData, setPaginationData] = useState<any>(null);
    const [listExperiences, setListExperiences] = useState<ExperienceSummary[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(0);
    const limit = 5;
    const history = useHistory()
    const confirm = useConfirmAction()

    const getDataExperience = async (page:number,offset:number=0) => {
        const experiences = await getActiveExperiences({ limit, offset, status: `${EXPERIENCE_STATUS.DRAFT}` });
        setPaginationData(experiences);
        setListExperiences(experiences.results);
        setCurrentPage(page);
    }

    const fetchData = async () => {
        setIsLoading(true);
        const duration = await getDurations();
        setDurations(duration.results);
        await getDataExperience(1,0);
        setIsLoading(false);
    }

    useEffect(() => {
        fetchData();
    },[])

    const totalPages = paginationData
        ? Math.ceil(paginationData.count / limit)
        : 1;

    const handlePageChange = async (page: number) => {
        const offset = (page - 1) * limit;
        await getDataExperience(1,offset);
    };

    const goto = (route:string) => {
        history.push(route)
    }

    const handleToDelete = async (id:number) => {
        let response = await confirm({ title: 'Delete Draft', message: 'This Draft Will Be Permanently Deleted. Continue?' });
        if (response) {
            let deleted = await deleteExperience(id);
            showErrorAlert({ title: 'Deleted', message: 'Experience deleted' });
            await getDataExperience(1);
        }
    }

    const hasRejectionInfo = (exp: ExperienceSummary) => {
        const info = (exp as any)?.rejectionInfo || (exp as any)?.rejection_info;
        if (Array.isArray(info)) {
            return info.length > 0;
        }
        return Boolean(info);
    };

    return (
        <div className="tap-host-secction-experiences-past-wrapper">
            <div className={`tap-host-section ${listExperiences.length > 0 ? '' : 'd-none'}`}>
                <div className='w-100 d-flex flex-row justify-content-between'>
                    <div className="tap-add-experience-2-btn-main" onClick={()=>history.goBack()}>
                        <div className="tap-host-button-text tap-flex-center">
                            Go Back
                        </div>
                    </div>
                    <div className="">
                        &nbsp;
                    </div>
                </div>
                <div className="tap-host-description-group">
                    <div className="tap-host-description-block">
                        <div className="tap-host-description-title">Continue Crafting Your Experiences</div>
                        <div className="tap-host-description-text">
                            Here you’ll find your saved experiences—exclusive invitations in progress. Refine, complete, or withdraw them before sharing with the Nobilis community.
                        </div>
                    </div>
                </div>

            </div>
            <div className={`tap-host-secction-experiences-past-list ${listExperiences.length == 0 ? '' : 'd-none'}`}>
                <div className='w-100 d-flex flex-row justify-content-between'>
                    <div className="tap-add-experience-2-btn-main" onClick={()=>history.goBack()}>
                        <div className="tap-host-button-text tap-flex-center">
                            Go Back
                        </div>
                    </div>
                    <div>
                        &nbsp;
                    </div>
                </div>
                <div className="tap-host-description-group">
                    <div className="tap-host-description-block">
                        <div className="tap-host-description-title">No Draft Experiences Found</div>
                        <div className="tap-host-description-text">
                            You don’t have any saved drafts right now. Ready to host? Create a new experience and share something unforgettable.
                        </div>
                    </div>
                </div>
            </div>
            <div className={`tap-host-secction-experiences-past-list ${isLoading ? '' : 'd-none'}`}>
                <div className='loader-experience'></div>
            </div>
            <div className="tap-host-secction-experiences-past-cards">
                {(listExperiences ?? []).map((exp:ExperienceSummary, index:number) =>
                    (<div key={`experiences-my-host-past-${index}`} className="tap-host-secction-experiences-past-card mb-3">

                        {/* LEFT IMAGE */}
                        <div className="tap-host-secction-experiences-past-img-wrapper tap-flex-center cursor-pointer" onClick={()=>history.push(`/experience/detail/${exp.id}`)}>
                            <img className="tap-host-secction-experiences-past-img" src={exp.coverImage ?? defaultVerticalImage} onError={handleImageErrorGray} alt={exp.title}/>

                            <div className="tap-host-secction-experiences-past-img-overlay">
                                <div className="tap-host-secction-experiences-past-img-title">
                                    {exp.title}
                                </div>
                            </div>
                        </div>

                        {/* RIGHT CONTENT */}
                        <div className="tap-host-secction-experiences-past-details">

                            {/* HOSTS */}
                            <div className="tap-host-secction-experiences-past-host-group">
                                <div className="tap-host-secction-experiences-past-host">
                                    <img src={exp?.host?.profilePicture ?? defaultProfileImage} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} className="tap-host-secction-experiences-past-host-img" alt={exp?.title} />
                                    <div className="tap-host-secction-experiences-past-host-name">
                                        {exp.host.firstName} {exp.host.lastName ?? ''}
                                    </div>
                                </div>
                            </div>

                            {/* INFO BOX */}
                            <div className="tap-host-secction-experiences-past-info-box cursor-pointer" onClick={()=>history.push(`/experience/detail/${exp.id}`)}>
                                <div className="tap-host-secction-experiences-past-info-row">
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-location">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_location.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {exp.city !== '' ? exp.city : 'N/A'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-calendar">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_date.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {exp?.dates?.length>0 ? formatDateShortIntl2(exp?.dates[0]?.start) : 'N/A'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-user">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_person.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            Max {exp.guestCapacity.max} Guests
                                        </div>
                                    </div>
                                </div>

                                <div className="tap-host-secction-experiences-past-info-row">
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-dollar">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_usd.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {formatUsdAmount(exp.pricePerGuest) || 'N/A'}&nbsp;/&nbsp;{exp?.priceType === 2 || (exp as any)?.price_type === 2 ? 'Group' : 'Guest'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-clock">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_hour.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {formatDurationLabel(exp.duration, pickDurationName(durations, exp.durationType)) || 'N/A'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item"></div>
                                </div>
                            </div>

                            {/* BOTTOM ACTIONS */}
                            <div className="tap-host-secction-experiences-past-actions">
                                {hasRejectionInfo(exp) ? (
                                    <div className="cursor-pointer" onClick={() => { setSelectedItem(exp.id); setShowDeclineModal(true); }}>
                                        <div style={{width: '100%', height: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'inline-flex'}}>
                                            <div style={{alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
                                                <div style={{textAlign: 'center', color: '#A50F0F', fontSize: 12, fontFamily: 'Satoshi', fontWeight: '500', textDecoration: 'underline', textTransform: 'uppercase', lineHeight: '16.80px', wordWrap: 'break-word'}}>DECLINE REASONS</div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                                <div className="tap-host-secction-experiences-past-buttons"></div>
                                <div className="tap-host-secction-experiences-past-buttons">
                                    <div role='button' onClick={()=>handleToDelete(exp.id)} className="tap-host-secction-experiences-past-btn-view cursor-pointer">
                                        <span>Delete</span>
                                    </div>
                                    <div role='button' onClick={()=>goto(`/experience/edit/${exp.id}`)} className="tap-add-experience-2-btn-secondary">
                                        Continue Editing
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>)
                )}
            </div>
            {listExperiences.length > 0 && paginationData && (<div className='text-start mt-5'>
                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            </div>)}
            {selectedItem > 0 && (
                <DeclineReasonsModal experienceId={selectedItem} open={showDeclineModal} onCancel={()=>setShowDeclineModal(false)} />
            )}
        </div>

    )
}

export { SectionDraft }